import { IconButton, Tooltip, SxProps, Theme } from '@mui/material';

interface IconButtonWhiteBgProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  id: string;
  cypressId: string;
  tooltip: string;
  sx?: SxProps<Theme>;
}

const IconButtonWhiteBg: React.FC<IconButtonWhiteBgProps> = ({
  children,
  onClick,
  disabled = false,
  cypressId,
  id,
  tooltip,
  sx,
}) => {
  return (
    <Tooltip placement="top" title={tooltip} disableFocusListener disableTouchListener>
      <div style={{ cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative' }}>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltip}
          data-cy={cypressId}
          id={id}
          sx={{
            padding: '8px',
            border: '1px solid #BDC3D2',
            borderRadius: '6px',
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
            cursor: disabled ? 'not-allowed' : 'pointer',
            '&[disabled]': {
              backgroundColor: '#f5f5f5',
              cursor: 'not-allowed',
            },
            ...(sx as any),
          }}
        >
          {children}
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default IconButtonWhiteBg;
